export const api =
  "https://raw.githubusercontent.com/saaslabsco/frontend-assignment/refs/heads/master/frontend-assignment.json";


export const PREV = "Prev";
export const NEXT = "Next";
